import { mapResponsiveDimensionsToPx as d } from "../../styles/dimensions/dimensions.js";
import { responsiveToCss as e } from "./utils.js";
function t(r, n, i) {
  const o = d(
    n
  );
  return e(r, o, i);
}
function R(r, n) {
  return t("margin", r, n);
}
function u(r, n) {
  return t("margin-top", r, n);
}
function f(r, n) {
  return t("margin-bottom", r, n);
}
function g(r, n) {
  return t("margin-left", r, n);
}
function c(r, n) {
  return t("margin-right", r, n);
}
function w(r, n) {
  return r ? c(r, n) + g(r, n) : "";
}
function T(r, n) {
  return r ? u(r, n) + f(r, n) : "";
}
function B(r, n) {
  return t("padding", r, n);
}
function p(r, n) {
  return t("padding-top", r, n);
}
function a(r, n) {
  return t("padding-bottom", r, n);
}
function b(r, n) {
  return t("padding-left", r, n);
}
function m(r, n) {
  return t("padding-right", r, n);
}
function L(r, n) {
  return r ? m(r, n) + b(r, n) : "";
}
function W(r, n) {
  return r ? p(r, n) + a(r, n) : "";
}
function x(r, n) {
  return t("border-radius", r, n);
}
function D(r, n) {
  return t("border-bottom-left-radius", r, n);
}
function P(r, n) {
  return t("border-bottom-right-radius", r, n);
}
function X(r, n) {
  return t("border-top-left-radius", r, n);
}
function Y(r, n) {
  return t("border-top-right-radius", r, n);
}
function C(r, n) {
  return t("border-width", r, n);
}
function G(r, n) {
  return t("border-right-width", r, n);
}
function j(r, n) {
  return t("border-left-width", r, n);
}
function k(r, n) {
  return t("border-top-width", r, n);
}
function q(r, n) {
  return t("border-bottom-width", r, n);
}
function y(r, n) {
  return t("grid-row-gap", r, n);
}
function z(r, n) {
  return t("gap", r, n);
}
export {
  D as borderBottomLeftRadius,
  P as borderBottomRightRadius,
  q as borderBottomWidth,
  j as borderLeftWidth,
  x as borderRadius,
  G as borderRightWidth,
  X as borderTopLeftRadius,
  Y as borderTopRightRadius,
  k as borderTopWidth,
  C as borderWidth,
  z as gap,
  y as gridRowGap,
  R as margin,
  f as marginBottom,
  g as marginLeft,
  c as marginRight,
  u as marginTop,
  w as marginX,
  T as marginY,
  B as padding,
  a as paddingBottom,
  b as paddingLeft,
  m as paddingRight,
  p as paddingTop,
  L as paddingX,
  W as paddingY
};
